import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Accordion from '../LazyWidgets/Accordion';
import { LEGEND_COLORS } from '../../src/ReportsTabs/reports-constants';
import s from './TreeView.module.css';

const TreeView = (props) => {
  // eslint-disable-next-line
  const { nodes, level, onTabChange, handleClick, dispatch, ...otherProps } = props;
  const accordionLevel = level || 0;
  const accordionClass = clsx({
    [s.accordion]: true,
    [s.accordionRoot]: accordionLevel === 0,
  });

  const handleChange = (index) => {
    if (props.handleClick) {
      const node = props.nodes[index];
      props.handleClick(node);
    }
  };

  return (<Accordion mode="multiple" className={accordionClass} onChange={handleChange} {...otherProps}>
    {nodes.map((node) => {
      const { id, type, title, url, expanded, active, dataTestId, nodes: childNodes } = node;

      const titleClass = clsx({
        [s.accordionTitle]: true,
        [s.accordionExpandableTitle]: !!childNodes,
        [s.accordionTitleTextSelected]: active,
      });
      const leafClass = clsx({
        [s.accordionTitle]: true,
        [s.accordionTitleLeaf]: true,
      });
      const paddingLeft = (accordionLevel === 0) ? 22 : (30 + (12 * accordionLevel));

      const titleComponent = childNodes ?
        (<Accordion.AccordionTitle
          className={titleClass}
          iconClosed={{ type: 'chevron_right', fill: LEGEND_COLORS.BLACK }}
          iconOpen={{ type: 'chevron_down', fill: LEGEND_COLORS.BLACK }}
          style={{ paddingLeft: `${paddingLeft}px` }}
          data-test-id={dataTestId}
        >
          {title}
        </Accordion.AccordionTitle>)
        : (<Accordion.AccordionBody
          className={leafClass}
          active
        >
          {active ? <div className={s.accordionTitleTextSelected} style={{ paddingLeft: `${paddingLeft}px` }}>{title}</div>
            : <button
              role="link"
              className={s.accordionLink}
              style={{ paddingLeft: `${paddingLeft}px` }}
              onClick={() => {
                onTabChange(url);
              }}
            >
              <div>{title}</div>
            </button>}
        </Accordion.AccordionBody>);

      const itemClass = clsx({
        [s.accordionItem]: true,
        [s.accordionItemSelected]: active && !childNodes,
      });

      const bodyClass = clsx({
        [s.accordionBody]: true,
        [s.accordionLeaf]: !childNodes,
      });
      const bodyProps = {
        className: bodyClass,
      };

      if (!childNodes) {
        bodyProps['aria-hidden'] = 'true';
      }

      if (expanded) {
        bodyProps.active = 'true';
      }

      return (<Accordion.AccordionItem key={`node-${id}-${type || ''}`} className={itemClass}>
        {titleComponent}
        <Accordion.AccordionBody {...bodyProps} >
          {childNodes && <TreeView nodes={childNodes} level={accordionLevel + 1} onTabChange={onTabChange} handleClick={handleClick} />}
        </Accordion.AccordionBody>
      </Accordion.AccordionItem>);
    })}
  </Accordion>);
};

TreeView.propTypes = {
  nodes: PropTypes.array.isRequired,
  level: PropTypes.number,
  onTabChange: PropTypes.func,
  handleClick: PropTypes.func,
};

export default TreeView;
